import { AppConfigKey_FE } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKey_PertinentCategory_Order } from '@app/advisor-ui-shared';
export const ConfigKeyFE_PertinentCategory_Order = new AppConfigKey_FE(ConfigKey_PertinentCategory_Order);
//# sourceMappingURL=app-configs.js.map